import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, OnDestroy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { OrderReschedulePayload } from "@features/order-actions/models/order-reschedule.model";
import { OrderRescheduleState } from "@features/order-actions/services/order-reschedule.state";
import { HorusLoadingComponent } from "@shared/components/domain/horus-loading/horus-loading.component";
import { HorusMessageGeneralComponent } from "@shared/components/domain/horus-message-general/horus-message-general.component";
import { AvailableDatePipe } from "../../../../../shared/pipes/available-date.pipe";
import { getAriaTicketUrl } from "app/core/utils/url";
import { OrderActionBase } from "@features/order-actions/models/order-action.model";
import { HorusBtnDirective } from "@shared/directives/horus-btn.directive";

@Component({
  selector: "app-confirm-dialog",
  standalone: true,
  imports: [
    CommonModule,
    MatIcon,
    HorusLoadingComponent,
    HorusMessageGeneralComponent,
    AvailableDatePipe,
    HorusBtnDirective,
  ],
  templateUrl: "./confirm-dialog.component.html",
  styleUrl: "./confirm-dialog.component.scss",
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  private readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  readonly state = inject(OrderRescheduleState);
  private readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    console.log("Confirming order reschedule", this.payload);
  }
  readonly payload = inject<OrderReschedulePayload & OrderActionBase>(
    MAT_DIALOG_DATA,
  );

  onConfirm(): void {
    this.state.rescheduleOrder(this.payload);
  }

  retry(): void {
    this.state.resetSubmitState();
    this.onConfirm();
  }

  close(): void {
    this.state.resetSubmitState();
    this.dialogRef.close();
  }

  closeAll(): void {
    this.state.resetSubmitState();
    this.dialog.closeAll();
  }

  redirectToAria(): void {
    const tenantId = this.payload.tenantId;
    const orderId = this.payload.orderId;
    const orderType = this.payload.orderType;

    if (!tenantId || !orderId || !orderType) return;

    const url = getAriaTicketUrl(tenantId, orderId, orderType);
    window.open(url, "_blank");
    this.closeAll();
  }

  ngOnDestroy(): void {
    this.state.resetSubmitState();
  }
}
